/** 操作の近くに薄く添えるキーボードショートカット表記 (例: "⌘K")。 */
export function ShortcutHint({ combo }: { combo: string }) {
	return <span className="shrink-0 font-mono text-section text-fg-3">{combo}</span>;
}
